import React from 'react';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';

import MyContractsTabs from 'components/MyContractsTabs';
import KnowMoreAboutContract from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import EPARGNContractInfo from 'components/MyContractInfo/EPARGNContractInfo';
import moment from 'moment';
import {
  getContractsEpargnSelector,
  getIsLoadingContractEpargnSelector,
} from 'store/contract/selectors';
import { get } from 'lodash';
import { renderUnit, currencyFormat, renderLinkFile } from 'utils/string';
import FilesEpargn from 'containers/EpargnDetailsPage/FilesEpargn';
import { ColoredDivider } from 'containers/EpargnDetailsPage/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import {
  EPARGN_PRODUCT_SCR,
  EPARGN_PRODUCT_SCR_NAME,
} from 'constants/globalConstants';

const MyContractsEpargn = (props: {
  intl: IntlShape;
  isLoadingContractEpargn: boolean;
  contractsEpargn: {
    infoPolice: {
      NUMERO_POLICE: string;
      PRENOM_ASSURE: string;
      NOM_ASSURE: string;
      DATE_EFFET: string;
      DATE_SITUATION: string;
      CAPITAL_CONSTITUE_SS_PB: number;
      LIBELLE_PRODUIT: string;
    };
  }[];
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <>
      <KnowMoreAboutContract />
      <MyContractsTabs
        isEpargn={true}
        tabItems={
          props.contractsEpargn &&
          props.contractsEpargn.map(
            (item: {
              infoPolice: {
                NUMERO_POLICE: string;
                PRENOM_ASSURE: string;
                NOM_ASSURE: string;
                DATE_EFFET: string;
                DATE_SITUATION: string;
                CAPITAL_CONSTITUE_SS_PB: number;
                LIBELLE_PRODUIT: string;
              };
            }) => ({
              label:
                get(item, 'infoPolice.CODE_PRODUIT') === EPARGN_PRODUCT_SCR
                  ? EPARGN_PRODUCT_SCR_NAME
                  : get(item, 'infoPolice.LIBELLE_PRODUIT'),
              contractNumber: get(item, 'infoPolice.NUMERO_POLICE'),
              circulationDate: 'circulationDate',
              content: (
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <EPARGNContractInfo
                      numContract={get(item, 'infoPolice.NUMERO_POLICE')}
                      souscripteur={
                        get(item, 'infoPolice.PRENOM_ASSURE') +
                        ' ' +
                        get(item, 'infoPolice.NOM_ASSURE')
                      }
                      dateEffet={moment(get(item, 'infoPolice.DATE_EFFET'))
                        .format('DD/MM/YYYY')
                        .toString()}
                      dateSituation={moment(
                        get(item, 'infoPolice.DATE_SITUATION'),
                        'YYYY-MM-DD',
                      )
                        .format('DD/MM/YYYY')
                        .toString()}
                      EpargnBrute={
                        get(item, 'infoPolice.CODE_PRODUIT') ===
                        EPARGN_PRODUCT_SCR
                          ? `${currencyFormat(
                              get(item, 'infoPolice.SCR_CAPIT_OU_RENTE_GAR'),
                            )} ${renderUnit(
                              get(item, 'infoPolice.SCR_CAPIT_OU_RENTE_GAR'),
                              reverse,
                            )}`
                          : `${currencyFormat(
                              get(item, 'infoPolice.CAPITAL_CONSTITUE_SS_PB'),
                            )} ${renderUnit(
                              get(item, 'infoPolice.CAPITAL_CONSTITUE_SS_PB'),
                              reverse,
                            )}`
                      }
                      numMembership={get(item, 'infoPolice.NUMERO_ADHESION')}
                      ppr={get(item, 'infoPolice.PPR')}
                      product={get(item, 'infoPolice.CODE_PRODUIT')}
                    />
                  </Grid>
                  {get(item, 'infoPolice.CODE_PRODUIT') !== 801 ? (
                    <>
                      <Grid item xs={12}>
                        <ColoredDivider orientation="horizontal" />
                      </Grid>
                      <Grid item xs={12}>
                        <FilesEpargn
                          numPolice={get(item, 'infoPolice.NUMERO_POLICE')}
                          codeProduit={get(item, 'infoPolice.CODE_PRODUIT')}
                          numAdhesion={get(item, 'infoPolice.NUMERO_ADHESION')}
                          matricule={get(item, 'infoPolice.MATRCICULE')}
                          ppr={get(item, 'infoPolice.PPR')}
                          isAttestation={true}
                          files={[
                            {
                              uri: renderLinkFile(
                                get(item, 'infoPolice.CODE_PRODUIT'),
                              ),
                              category: 'conditions_generales',
                            },
                          ]}
                        />
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </Grid>
              ),
            }),
          )
        }
        getDetailContract={() => {}}
        isLoadingDetailContract={props.isLoadingContractEpargn}
        category={EVENT_CATEGORIES.EPARGN_DETAILS}
        label={'Tab 2: Mes contrats'}
      />
    </>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    contractsEpargn: any;
    isLoadingContractEpargn: boolean;
  }
>({
  contractsEpargn: getContractsEpargnSelector,
  isLoadingContractEpargn: getIsLoadingContractEpargnSelector,
});

export default connect(mapStateToProps, {})(injectIntl(MyContractsEpargn));
export { MyContractsEpargn as MyContractsEpargnTest };
